import { FC } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import { routes } from 'src/constants/routes';
import { OccupantDetailsPage } from 'src/pages/occupant-details/occupant-details-page';
import { SuccessPage } from 'src/pages/success';
import { SuccessPageOria } from 'src/pages/success-oria';
import { HosSuccessPage } from 'src/pages/hos-sucess';
import { FailurePage } from 'src/pages/failure';
import { AbortedPage } from 'src/pages/aborted';
import { SetPasswordPage } from 'src/pages/set-password';
import { ProcessingAmendPage, ProcessingPage } from 'src/pages/processing';
import { RoomNotAvailable } from 'src/pages/room-not-available';
import { BrochureCallbackPage } from 'src/pages/brochure-callback/brochure-callback';
import { NoRoomSelected } from 'src/pages/no-room-selected/no-room-seleted';
import { getTheme } from 'src/utils/getTheme';
import { BookingUpdatedPage } from 'src/pages/booking-updated';
import { BookingUpdateFailurePage } from 'src/pages/booking-update-failure';
import { BookingUpdateExpiredPage } from 'src/pages/booking-update-expired';
import { NotFoundPage } from 'src/pages/not-found';
import { MakeAPaymentPage } from 'src/pages/make-a-payment';
import { PaymentSuccessfulPage } from 'src/pages/paymentSuccessful';
import { ResetPasswordPage } from 'src/features/login-dialog/supabase/reset-password-page';
import { BookingFlowContainer } from 'src/pages/booking-flow-container/booking-flow-container';

import { BookingSummaryContainer } from '../pages/booking-summary/booking-summary-container';
import { AmendBookingContainer } from '../pages/amend/components/amend-booking-container';
import { BasketGuard } from '../components/basket-guard/basket-guard';
import { AmendBookingSummary } from '../pages/amend/components/amend-booking-summary';

const { isHosTheme } = getTheme();

export const Routing: FC = () => (
    <Routes>
        <Route path="*" element={<Navigate to={routes.notFound.index} />} />
        <Route path={routes.index} element={<Navigate to={routes.summary.index} />} />
        <Route path={routes.summary.index} element={<BookingSummaryContainer />} />
        <Route path={routes.occupant.createPassword} element={<SetPasswordPage />} />
        <Route path={routes.occupant.details} element={<OccupantDetailsPage />} />
        <Route
            path={routes.success.index}
            element={isHosTheme ? <HosSuccessPage /> : <SuccessPage />}
        />
        <Route path={routes.success.oria} element={<SuccessPageOria />} />
        <Route path={routes.paymentSuccessful.index} element={<PaymentSuccessfulPage />} />
        <Route path={routes.failure.index} element={<FailurePage />} />
        <Route path={routes.aborted.index} element={<AbortedPage />} />
        <Route path={routes.brochureCallback.index} element={<BrochureCallbackPage />} />
        <Route path={routes.amendBooking.index} element={<AmendBookingContainer />} />
        <Route path={routes.processing.index} element={<ProcessingPage />} />
        <Route path={routes.processing.amend} element={<ProcessingAmendPage />} />
        <Route path={routes.roomNotAvailable.index} element={<RoomNotAvailable />} />
        <Route path={routes.noRoomSelected.index} element={<NoRoomSelected />} />
        <Route path={routes.bookingUpdated.index} element={<BookingUpdatedPage />} />
        <Route path={routes.failure.update} element={<BookingUpdateFailurePage />} />
        <Route path={routes.bookingUpdateExpired.index} element={<BookingUpdateExpiredPage />} />
        <Route path={routes.notFound.index} element={<NotFoundPage />} />
        <Route path={routes.makeAPayment.index} element={<MakeAPaymentPage />} />
        <Route path={routes.auth.resetPassword} element={<ResetPasswordPage />} />
        <Route
            path={routes.yourDetails.index}
            element={<BasketGuard component={BookingFlowContainer} componentProps={{ step: 0 }} />}
        />
        <Route
            path={routes.roommates.index}
            element={<BasketGuard component={BookingFlowContainer} componentProps={{ step: 1 }} />}
        />
        <Route
            path={routes.agreements.index}
            element={<BasketGuard component={BookingFlowContainer} componentProps={{ step: 2 }} />}
        />
        <Route path={routes.amendBooking.summary} element={<AmendBookingSummary />} />
    </Routes>
);
